import { apiGet, USE_MOCK_API } from './httpClient'
export interface PlaceSearchResult { title: string; address: string; lat: number; lng: number; provider_id: string | null; source: string }
const DEMO_PLACES: PlaceSearchResult[] = [
  { title: 'Rome', address: 'Italy', lat: 41.9028, lng: 12.4964, provider_id: 'demo-rome', source: 'demo' },
  { title: 'Paris', address: 'France', lat: 48.8566, lng: 2.3522, provider_id: 'demo-paris', source: 'demo' },
  { title: 'Jerusalem', address: 'Israel', lat: 31.7683, lng: 35.2137, provider_id: 'demo-jerusalem', source: 'demo' },
  { title: 'Tel Aviv', address: 'Israel', lat: 32.0853, lng: 34.7818, provider_id: 'demo-tel-aviv', source: 'demo' },
]
export async function searchPlaces(text: string, lang: string): Promise<PlaceSearchResult[]> {
  if (USE_MOCK_API) return DEMO_PLACES.filter(p => `${p.title} ${p.address}`.toLowerCase().includes(text.trim().toLowerCase()))
  return apiGet(`/places/search?text=${encodeURIComponent(text)}&lang=${encodeURIComponent(lang)}`)
}
